/* RESPONSIBLE TEAM: team-conversations */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import { isEmpty, isNone } from '@ember/utils';
import Service, { inject as service } from '@ember/service';
import Metrics from 'embercom/models/metrics';

export default Service.extend({
  store: service(),

  updateCompanyData(companyData) {
    let company = this.store.peekRecord('company', companyData.id);
    if (!company) {
      this.store.createRecord('company', companyData);
      return this.updateCompanyData(companyData);
    }
    this.updateData(company, companyData);
    return company;
  },

  updateData(model, data) {
    let userDetailsDidUpdate = false;
    let displayAsDidUpdate = false;

    Object.keys(data).forEach((attribute) => {
      let newValue = data[attribute];
      let currentValue = model.get(attribute);
      if (this._shouldUpdateAttribute(attribute, newValue, currentValue)) {
        try {
          if (attribute === 'companies') {
            let hadNoCompanies = isEmpty(currentValue);
            newValue.forEach((companyData) => {
              let company = this.updateCompanyData(companyData);
              if (hadNoCompanies) {
                currentValue.addObject(company);
              }
            });
          } else {
            model.set(attribute, newValue);
          }
          userDetailsDidUpdate = true;
          displayAsDidUpdate = displayAsDidUpdate || attribute === 'display_as';
        } catch (e) {
          Metrics.capture({ increment: ['user_updater_service_error'] });
        }
      }
    });

    if (userDetailsDidUpdate) {
      model.set('_lastEdit', new Date());
    }

    model.setProperties({ userDetailsDidUpdate, displayAsDidUpdate });
  },

  _shouldUpdateAttribute(attribute, newValue, currentValue) {
    if (attribute === 'eventName') {
      return false;
    } else if (isNone(newValue) && isNone(currentValue)) {
      return false;
    } else {
      return !_.isEqual(newValue, currentValue);
    }
  },
});
